import { ArrowBack as CancelIcon, Save as SaveIcon } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { CardActions, CardContent, Grid } from '@mui/material';
import type { FormikProps } from 'formik';
import type { FC } from 'react';
import { FormikSwitch } from '../../components/formik-fields/switch.js';
import { FormikTextField } from '../../components/formik-fields/text-field.js';
import { CenterCard } from '../../components/page-layout/center-card.js';
import type { EditViewProps } from '../../utils/types.js';

export interface VehicleFormValues {
  color: string;
  hasLivery: boolean;
  make: string;
  model: string;
  rego: string;
}

interface Props extends EditViewProps<VehicleFormValues> {
  formik: FormikProps<VehicleFormValues>;
  isEditing?: boolean;
}

export const VehicleFormView: FC<Props> = ({ cancel, formik, isEditing }) => {
  return (
    <form onReset={formik.handleReset} onSubmit={formik.handleSubmit}>
      <CenterCard>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item md={6} xs={12}>
              <FormikTextField
                disabled={isEditing}
                formik={formik}
                helperText="Vehicle registration number"
                id="rego"
                inputProps={{
                  sx: { textTransform: 'uppercase' },
                }}
                label="Registration"
                required
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <FormikTextField
                formik={formik}
                id="make"
                label="Make"
                required
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <FormikTextField
                formik={formik}
                id="model"
                label="Model"
                required
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <FormikTextField
                formik={formik}
                id="color"
                label="Color"
                required
              />
            </Grid>
            <Grid item xs={12}>
              <FormikSwitch formik={formik} id="hasLivery" label="Has Livery" />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions sx={{ justifyContent: 'space-between' }}>
          <LoadingButton
            color="inherit"
            onClick={cancel}
            startIcon={<CancelIcon />}
            variant="text"
          >
            Cancel
          </LoadingButton>
          <LoadingButton
            loading={formik.isSubmitting}
            startIcon={<SaveIcon />}
            type="submit"
            variant="contained"
          >
            Save
          </LoadingButton>
        </CardActions>
      </CenterCard>
    </form>
  );
};
